module.exports = __webpack_public_path__ + "static/img/logo12.e6bb4b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo12.jpg
// module id = wM2J
// module chunks = 1